import { SourcingPerformanceStatus } from 'api-clients/monolith';
import { useIntl } from 'react-intl';

import { LightningBolt } from '@/components/icons/lightning-bolt';
import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';

interface AutomationActionPillProps {
  status: SourcingPerformanceStatus;
}

export function AutomationActionPill({ status }: AutomationActionPillProps) {
  const intl = useIntl();
  if (!(status === 'at_risk' || status === 'goal_met')) {
    return null;
  }
  const messages = {
    at_risk: intl.formatMessage({
      defaultMessage: 'Sourcing automatically resumed',
    }),
    goal_met: intl.formatMessage({
      defaultMessage: 'Sourcing automatically paused',
    }),
  };

  return (
    <div className="bg-fx-brand-50 align-items-center flex gap-2 whitespace-nowrap rounded-sm px-2 py-1.5">
      <LightningBolt className="text-fx-primary h-4 w-4" />
      <Typography variant="body1" className="!text-fx-neutral-900">
        {messages[status]}
      </Typography>
    </div>
  );
}

AutomationActionPill.Skeleton = function AutomationActionPillSkeleton() {
  return (
    <div className="bg-fx-brand-50 flex h-6 w-fit place-items-center justify-center gap-1 whitespace-nowrap rounded-full pl-2 pr-3">
      <LightningBolt className="text-fx-primary h-4 w-4" />
      <Skeleton className="h-4 w-4" />
    </div>
  );
};
